import React from 'react'

const WayniCreditIcon = () => (
  <svg
    width='32'
    height='33'
    viewBox='0 0 32 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16' cy='16.5' r='15.5' stroke='#2A1846' />
    <path
      d='M10.5361 16.4357V13.8304C10.5361 12.9781 11.064 12.2146 11.861 11.9134L17.5655 9.75946C18.4595 9.42277 19.4142 10.0825 19.4142 11.0379V13.3257'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.5844 17.9349C19.4902 17.9356 19.4144 18.0121 19.4144 18.1063C19.4144 18.2005 19.4909 18.277 19.5851 18.2764C19.6794 18.2764 19.7558 18.1999 19.7558 18.1056C19.7558 18.0114 19.6794 17.9349 19.5844 17.9349'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.0858 22.6462H20.0971C21.2239 22.6462 22.1459 21.7243 22.1459 20.5974V15.3737C22.1459 14.2421 21.2287 13.325 20.0971 13.325H11.902C11.1474 13.325 10.5361 13.9362 10.5361 14.6908V16.6754'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9265 23.3293C10.8525 23.3293 9.17041 21.6473 9.17041 19.5732C9.17041 17.4992 10.8525 15.8171 12.9265 15.8171C15.0012 15.8171 16.6826 17.4992 16.6826 19.5732C16.6826 21.6473 15.0012 23.3293 12.9265 23.3293'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9264 18.0754V21.0714'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.424 19.5732H11.4287'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default WayniCreditIcon
